import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { OpenCase, Submission, Well, ActiveJob } from '#models';
import openCasesData from '../app/data/openCases';
import submissionsData from '../app/data/submissions';
import wellsData from '../app/data/wells';
import activeJobsByWellData from '../app/data/activeJobs';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  getOpenCases(): Observable<OpenCase[]> {
    return of(openCasesData);
  }

  getSubmissions(): Observable<Submission[]> {
    return of(submissionsData);
  }

  getWells(): Observable<Well[]> {
    return of(wellsData);
  }

  getActiveJobsByWell(wellId: number): Observable<ActiveJob[]> {
    return of(activeJobsByWellData[wellId] || []);
  }

  getAllActiveJobs(): Observable<Record<number, ActiveJob[]>> {
    return of(activeJobsByWellData);
  }
}
